<script setup>
import { computed } from "vue";
import { useRequestsStore } from "@/stores/storeRequests";
import { useSettingsStore } from "@/stores/storeSettings";
import BaseCopyTooltip from "@/components/ui/BaseCopyTooltip.vue";
import TheViewTelegram from "@/pages_telegram/TheViewTelegram.vue";


const storeRequests = useRequestsStore();
const storeSettings = useSettingsStore();

const userReferraLink = computed(() => storeRequests.userData?.referral_link || "");
const userReferraCode = computed(() => (storeRequests.userData?.referral_code ? `${storeSettings.tgUrl}?ref=${storeRequests.userData?.referral_code}` : storeSettings.tgUrl));



const copy = async (text, show) => {
	await navigator.clipboard.writeText(text);
	show();
};

</script>
<template>
    <TheViewTelegram>        
        <div class="user-data">
            <div class="user-data__inner">
                <div class="user-data__invations">
                    <p class="user-data__invations-title">
                        Приглашайте друзей и получайте <span>+30</span><br>
                        за каждого приглашённого, а друг — <span>+10</span>
                        после регистрации по Вашей ссылке
                    </p>
                    <div class="user-data__invations-btns" >
                        <BaseCopyTooltip class="btn --small" title="Cкопировать" text="Ссылка скопирована">
                            <template #default="{ show }">
                                <span @click="copy(userReferraLink, show)">
                                    https://...
                                    <svg width="32" height="32"><use href="#copy"></use></svg>
                                </span>
                            </template>
                        </BaseCopyTooltip>
                        <BaseCopyTooltip class="btn --small" title="Cкопировать" text="Ссылка скопирована">
                            <template #default="{ show }">
                                <span @click="copy(userReferraCode, show)">
                                    Telegram
                                    <svg width="32" height="32"><use href="#telegram"></use></svg>
                                </span>
                            </template>
                        </BaseCopyTooltip>
                    </div>
                </div>
            </div>
        </div>
    </TheViewTelegram>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.user-data {
    display: grid;
    place-content: center;
	&__inner {
		display: grid;
		grid-template-columns: 50rem;
		gap: 1rem;
		align-items: start;
		@media (max-width: vars.$xx) {
			grid-template-columns: 1fr;
			gap: 3rem;
		}
	}

	&__invations {
		@extend .base-bg;
		border: 1px solid var(--border-accent-2-3);
		border-radius: 2.4rem;
		padding: 3.2rem 2.4rem 2.4rem;
		@media (max-width: vars.$x480) {
			    padding: 2.8rem 2.2rem 2.4rem;
		}
	}

	&__invations-title {
		font-weight: 500;
		font-size: 1.6rem;
		line-height: 144%;
		color: var(--text-inverse-100);
		margin-bottom: 2rem;
		@media (max-width: vars.$x480) {
			font-size: 1.4rem;
			line-height: 134%;
			    margin-bottom: 1.4rem;
		}

		span {
			position: relative;
			background-image: url("@/assets/img/icons/leaf.svg");
			background-repeat: no-repeat;
			background-position: 3.3rem 0px;
			background-size: contain;
			width: 5.5rem;
			display: inline-block;
			&:last-child {
				background-position: 3rem 0px;
			}
		}
		br {
			@media (max-width: vars.$x480) {
				display: none;
			}
		}
	}

	&__invations-btns {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 0.5rem;

		.btn {
			min-height: 3.2rem;
			font-size: 1.4rem;
			border-radius: 1rem;
			@media (max-width: vars.$x480) {
			}
			span {
				display: flex;
				justify-content: space-between;
				align-items: center;
				width: 100%;

				svg {
					width: 2.4rem;
					height: 2.4rem;
					@media (max-width: vars.$x480) {
					}
				}
			}
		}
	}
}
</style>
